/**
 * @file newCollegeStudentDemographics.js
 * @author Jake Stark
 * @desc newCollegeStudentDemographics report plugin

*/

/**
 * @module newCollegeStudentDemographics
 * @desc newCollegeStudentDemographics report plugin
 */

define('plugins/mobility',["underscore",
        "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/mobility_table.html", "text!plugins/templates/highSchoolAcademics_MCAProficiency_table.html", "text!plugins/templates/highSchoolAcademics_ACT_table.html"],
       function (_,
                  CardboardModels, CardboardCollections, Util,
                  mobilityTemplate, MCAProficiencyTemplate, ACTTemplate) {

    console.log("MODULE: highSchoolAcademics");

    var exports = {

        // options for the demo cats config. since this is a multi-select
        // report, we have to use a different view object, and tell it not to
        // show grades as categories.
        options: {
            dynamicTextDomain: "highSchoolAcademics",
            orgDetailPane: true,
            noMapSearch: true,
            forcedSummaryFilters: ["COHORTID"],
            definitions: true
        },

        // each of these is the configuration that gets passed to a
        // DataBoxPaneView.
        panes: [
            {
                title: "High School Graduates",
                //titlePath: "highSchoolAcademics.content.0",
                openByDefault: true,
                views: [
                    {
                        type: "template",
                        template: mobilityTemplate,
                        // template: "yo."
                        dataSourceName: "data"
                    }
                ]
            },
            {
                title: "HS Graduates Accountability Test Results",
                //titlePath: "highSchoolAcademics.content.1",
                explanationText: "<p>TEST Minnesota public high school data includes student records with a Status End code (\"8\" or \"9\"). These data are not the same student cohorts used by MDE to calculate the high school graudation rate. Also please note that new standards were implemented in 2011 for Mathematics and in 2013 for Reading. Comparisons in Mathematics prior to 2011 and in Reading prior to 2013 should not be made. For further information related to the implementation of new standards or the test changes, please see the <a href=\"https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary\" target=\"_blank\">Data Interpretation Guide</a>.</p>",
                //explanationTextPath: "highSchoolAcademics.content.2",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>HS Graduates Last Reported Math and Reading Test Results</h5>",
                        //templatePath: "highSchoolAccountability.content"
                    },
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "column",
                        dataSourceName: "data",
                        dataPath: "MCAProficiency.organizations",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",
                        dataDimensions: 2,

                        // DISPLAY
                        // xAxisLabelPath: "subjects.label",
                        unitString: "%",
                        showLegend: true,

                        // SERIES
                        // each series has two points, and is an organization
                        series: [
                            {
                                dataPath: "subjects",
                                valuePath: "percentProficient",
                                seriesDisplayNamePath: "orgName",
                                displayNamePath: "label",
                                color: "blue3"
                            },
                            {
                                dataPath: "subjects",
                                valuePath: "percentProficient",
                                seriesDisplayNamePath: "orgName",
                                displayNamePath: "label",
                                color: "green"
                            },
                            {
                                dataPath: "subjects",
                                valuePath: "percentProficient",
                                seriesDisplayNamePath: "orgName",
                                displayNamePath: "label",
                                color: "red"
                            }
                        ]
                    },
                    {
                        type: "template",
                        template: MCAProficiencyTemplate,
                        dataSourceName: "data"
                    }
                ]
            },
            {
                title: "ACT Mean Composite Score",
                explanationText: "This report shows Minnesota student's scores on the American College Test. This score can determine students preparation and readiness for postsecondary education.",
                openByDefault: false,
                views: [
                    {
                        type: "template",
                        template: "<h5>Of HS Graduates Taking the ACT</h5>"
                    },
                    {
                        // SETUP
                        // one glob = one line series
                        // in each series, one row = one data point
                        type: "column",

                        dataSourceName: "data",
                        dataPath: "ACT.organizations",

                        // "pointsWithinRows": given that the data is
                        // two-dimensional (meaning an array of arrays, or
                        // similar structure, implying that we have more than
                        // one series to plot) each series is contained in a
                        // "row", like so:
                        //	 +---------+
                        //	 | X X X X |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 | . . . . |
                        //	 +---------+
                        dataShape: "pointsWithinRows",

                        // since in this case there's only one dimension, due to
                        // there being only one series to plot, it looks like
                        // this:
                        //	 +---------+
                        //	 | X X X X |
                        //	 +---------+
                        dataDimensions: 1,

                        // DISPLAY
                        // xAxisLabelPath: "subjects.label",
                        unitString: "",
                        showLegend: false,
                        yAxisMax: 36,
                        yAxisTickInterval: 4,
                        colorByPoint: true,

                        // SERIES
                        series: [{
                            valuePath: "meanACT",
                            displayNamePath: "orgName",
                            colors: ["blue3", "green", "red"]
                        }]
                    },
                    {
                        type: "template",
                        template: ACTTemplate,
                        dataSourceName: "data"
                    }
                ]
            }
        ],

        filterSources: {
            filters: {
                modelType: CardboardModels.FilterData,
                url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_ecodevregion.fex",
                enabled: true
            },
            filters2: {
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_cohortid.fex",
                enabled: true,
                modelType: CardboardModels.FilterData
            },
            demographicCategories: {
                modelType: CardboardCollections.DemoCatProducer,
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_demographics.fex",
                enabled: true,
                noViewParams: true
            }
        },
        dataSources: {
            data: {
                modelType: CardboardModels.DocumentModel,
                url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_highSchoolAcademics.fex",
                yearPath: "dataYear",
                defaultParams: {
                    orgId: 999999000
                },
                paramMappings: {
                    HSGRAD_ORGID: "orgId",
                    orgName: null // skip this
                },
                postProcessor: function (data) {
                    // all we need to do is prettify all the org names!

                    var collections = [
                        data.graduates.organizations,
                        data.MCAProficiency.organizations,
                        data.ACT.organizations
                    ];

                    _(collections).each(function (collection) {
                        _(collection).each(function (blob) {
                            blob.orgName = Util.Data.prettifyName(blob.orgName);
                        });
                    });
                },
                enabled: true,
                errorConditions: [
                    {
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Sorry, we don't have any data for your selected school/district and year."
                        }
                    }
                ]
            }
        }
    };

    return exports;
});
